import app from 'flarum/forum/app';
import {extend, override} from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import Button from 'flarum/common/components/Button';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';

function openWordpressLoginModal() {
    const url = app.forum.attribute('baseUrl') + '/auth/wordpress';

    if (app.forum.attribute('kilowhatWordpressLoginPage')) {
        window.location.href = url + '?' + m.buildQueryString({
            return: window.location.href,
        });
        return;
    }

    const width = 380;
    const height = 500;
    const $window = $(window) as any;

    window.open(url, 'logInPopup',
        `width=${width},` +
        `height=${height},` +
        `top=${$window.height() / 2 - height / 2},` +
        `left=${$window.width() / 2 - width / 2},` +
        'status=no,scrollbars=no,resizable=no');
}

function failPromiseAndOpenLogin(original: (...args: any) => Promise<any>, ...args: any): Promise<any> {
    if (app.forum.attribute('kilowhatWordpressOnly') && !app.session.user) {
        openWordpressLoginModal();

        return Promise.reject();
    } else {
        return original(...args);
    }
}

export default function () {
    extend(LogInButtons.prototype, 'items', function (items) {
        if (!app.forum.attribute('kilowhatWordpressLogin')) {
            return;
        }

        items.add('kilowhat-wordpress', Button.component({
            className: 'Button LogInButton LogInButton--wordpress',
            icon: 'fab fa-wordpress',
            onclick: openWordpressLoginModal,
        }, app.translator.trans('kilowhat-wordpress.forum.log_in.with_wordpress_button')));
    });

    extend(HeaderSecondary.prototype, 'items', function (items) {
        if (app.session.user || !app.forum.attribute('kilowhatWordpressOnly')) {
            return;
        }

        items.remove('logIn');
        items.remove('signUp');

        items.add('kilowhat-wordpress', Button.component({
            className: 'Button Button--link',
            onclick: openWordpressLoginModal,
        }, app.translator.trans('core.forum.header.log_in_link')));
    });

    // Open our own WordPress modal instead of the login modal if the user is logged out
    override(DiscussionControls, 'replyAction', failPromiseAndOpenLogin);
    override(IndexPage.prototype, 'newDiscussionAction', failPromiseAndOpenLogin);
}
